// Scroll to section utility
export const scrollToSection = (sectionId) => {
  // Remove the # if it's present
  const id = sectionId.replace('#', '');
  
  const element = document.getElementById(id);
  if (element) {
    const headerOffset = 80; // Height of fixed header
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

// Handle scroll on page load if hash is present
export const handleHashScroll = () => {
  const hash = window.location.hash;
  if (hash) {
    // Wait for page to render
    setTimeout(() => {
      scrollToSection(hash);
    }, 100);
  }
};
